import { FormGroup, TextInput } from '@ksyos/design-system';
import {
    BeleidOptions,
    UrgenciesForConsultOogartsEnum,
    UrgenciesForConsultOptometrist,
} from '@common/validation/customControls/ophthalmology';
import { InputPeriod } from '@frontend/components/elements/InputPeriod';
import type { ICustomControlDiagnosticReportAddEditProps } from '../../interfaces/';
import { Feedback } from '../../../../elements/common';
import { SearchableEnumDropdown } from '../../../../elements/SearchableEnumDropdown';

export function OrthCV1DiagnosticReportAddEditBeleid(props: ICustomControlDiagnosticReportAddEditProps) {
    return (
        <>
            <FormGroup
                hasErrors={props.errors.has('customControlData.beleid')}
                isRequired
                label="Beleid"
            >
                <SearchableEnumDropdown
                    automation="beleid"
                    error={props.errors.get('customControlData.beleid')}
                    jsEnum={BeleidOptions}
                    onChange={async (value) => {
                        await props.handleChangeCustomControl({
                            beleid: value,
                            beleid_anders: null,
                            urgentie_anders: null,
                            urgentie_oogarts: null,
                            urgentie_optometrist: null,
                            termijn: null,
                        });
                        props.validateOneCustomControl('beleid');
                    }}
                    placeholder="Kies uit de lijst"
                    value={props.diagnosticReport.customControlData.beleid}
                />
            </FormGroup>

            {props.diagnosticReport.customControlData.beleid === BeleidOptions.anders && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.beleid_anders')}
                    isRequired={true}
                    label="Toelichting"
                >
                    <TextInput
                        className={props.errors.has('customControlData.beleid_anders') ? 'has-danger' : ''}
                        onChange={async (e) => {
                            await props.handleChangeCustomControl({
                                beleid_anders: e.target.value ? e.target.value : null,
                            });
                            await props.validateOneCustomControl('beleid_anders');
                        }}
                        placeholder="Toelichting"
                        value={props.diagnosticReport.customControlData.beleid_anders || ''}
                    />
                    <Feedback error={props.errors.get('customControlData.beleid_anders')} />
                </FormGroup>
            )}

            {props.diagnosticReport.customControlData.beleid === BeleidOptions.verwijzing_oogarts && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.urgentie_oogarts')}
                    isRequired={true}
                    label="Urgentie"
                >
                    <SearchableEnumDropdown
                        automation="urgentie"
                        error={props.errors.get('customControlData.urgentie_oogarts')}
                        jsEnum={UrgenciesForConsultOogartsEnum}
                        onChange={async (value) => {
                            await props.handleChangeCustomControl({
                                urgentie_oogarts: value,
                                urgentie_anders: null,
                            });
                            await props.validateOneCustomControl('urgentie_oogarts');
                        }}
                        placeholder="Kies uit de lijst"
                        value={props.diagnosticReport.customControlData.urgentie_oogarts}
                    />
                </FormGroup>
            )}

            {props.diagnosticReport.customControlData.beleid === BeleidOptions.verwijzing_optometrist && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.urgentie_optometrist')}
                    isRequired={true}
                    label="Urgentie"
                >
                    <SearchableEnumDropdown
                        automation="urgentie"
                        error={props.errors.get('customControlData.urgentie_optometrist')}
                        jsEnum={UrgenciesForConsultOptometrist}
                        onChange={async (value) => {
                            await props.handleChangeCustomControl({
                                urgentie_optometrist: value,
                                urgentie_anders: null,
                            });
                        }}
                        onDoValidate={async () => {
                            await props.validateOneCustomControl('urgentie_optometrist');
                        }}
                        placeholder="Kies uit de lijst"
                        value={props.diagnosticReport.customControlData.urgentie_optometrist}
                    />
                </FormGroup>
            )}

            {(props.diagnosticReport.customControlData.urgentie_optometrist === UrgenciesForConsultOptometrist.anders ||
                props.diagnosticReport.customControlData.urgentie_oogarts ===
                    UrgenciesForConsultOogartsEnum.anders) && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.urgentie_anders')}
                    isRequired={true}
                    label="Toelichting"
                >
                    <TextInput
                        className={props.errors.has('customControlData.urgentie_anders') ? 'has-danger' : ''}
                        onChange={async (e) => {
                            await props.handleChangeCustomControl({
                                urgentie_anders: e.target.value ? e.target.value : null,
                            });
                            await props.validateOneCustomControl('urgentie_anders');
                        }}
                        placeholder="Toelichting"
                        value={props.diagnosticReport.customControlData.urgentie_anders || ''}
                    />
                    <Feedback error={props.errors.get('customControlData.urgentie_anders')} />
                </FormGroup>
            )}

            {props.diagnosticReport.customControlData.beleid === BeleidOptions.revisie_orthoptist && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.termijn')}
                    isRequired={true}
                    label="Termijn"
                >
                    <InputPeriod
                        {...props}
                        errors={props.errors.get('customControlData.termijn')}
                        fieldKey="termijn"
                        value={props.diagnosticReport.customControlData.termijn}
                    />
                </FormGroup>
            )}
        </>
    );
}
